import { createFileRoute } from "@tanstack/react-router";
import { UploadPage } from "@/features/publiclinks/UploadPage";

/** Public upload link for one client. Sits outside the _app layout, so there is no app shell. */
export const Route = createFileRoute("/p/upload/$token")({
  component: UploadRoute,
});

function UploadRoute() {
  const { token } = Route.useParams();
  return <UploadPage token={token} />;
}
